const aliases = {
  '@base': 'https://f.hskcdn.com',
  '@video': 'https://f.hskcdn.com/sc/video',
  '@audio': 'https://f.hskcdn.com/sc/audio',
  '@oss0': 'https://f.hskcdn.com/old/web', // 老HSK文件地址
  '@oss': 'https://f.hskcdn.com/sc', // HSKOnline内容音频/图片基础地址
  '@img': 'https://f.hskcdn.com/cms', // 支持阿里云图片处理功能的基础地址
  '@cdn': 'https://f.hskcdn.com' // 通用CDN文件地址
}

var Utils = {
  url (url) {
    return url ? url.replace(/^@\w+/, m => {
      return aliases[m]
    }) : url
  },
  relativeUrl (url, baseUrl) {
    url = this.url(url)
    if (baseUrl) {
      baseUrl = this.url(baseUrl)
      let pos = url.indexOf(baseUrl)
      if (pos === 0) {
        return url.substring(baseUrl.length)
      }
    }
    return url.replace(/^\w+:\/\/[\\w\\.]+/, '')
  },
  asUrl (url, baseUrl) {
    return baseUrl + url.replace(/@[\w-]+|\w+:\/\/[\w\\.]+/, '')
  },
  asMillisecond (duration) {
    if (!duration) return 0
    let parts = duration.split('.')
    let ms = parts.length > 1 ? parts[parts.length - 1] : '0'
    return parts[0].split(':').reverse().reduce((total, val, index) => {
      return total + Number.parseInt(val) * Math.pow(60, index)
    }, 0) * 1e3 + Number.parseInt(ms.padEnd(3, '0'))
  },
  asDuration (time) {
    if (!time) return '00:00'
    let ms = time % 1e3
    time = Number.parseInt(time / 1e3)
    let arr = []
    if (time >= 3600) {
      arr.push(Number.parseInt(time / 3600))
      time %= 3600
    }
    if (time >= 60) {
      arr.push(Number.parseInt(time / 60))
      time %= 60
    } else {
      arr.push(0)
    }
    arr.push(time)
    let str = arr.map(n => n < 10 ? ('0' + n) : n).join(':')
    return ms > 0 ? (str + '.' + ms).replace(/0+$/, '') : str
  },
  getAttr (obj, path, def) {
    let i = path.indexOf('.')
    let name = i > 0 ? path.substring(0, i) : path
    if (name in obj) {
      let val = obj[name]
      if (val === null || val === undefined) {
        return def
      }
      return i > 0 ? this.getAttr(val, path.substring(i + 1), def) : val
    }
    return def
  },
  isEmptyValue (val) {
    return val === null || val === undefined || val === ''
  },
  isEmptyArray (val) {
    return val.length < 1
  },
  isEmptyObject (val) {
    for(let k in val) {
      return false
    }
    return true
  },
  isEmpty (val) {
    return Utils.isEmpty(val) 
      || (Array.isArray(val) && Utils.isEmptyArray(val)) 
      || (typeof val === 'object' && Utils.isEmptyObject(val))
  },
  filterData (val) {
    if (Array.isArray(val)) {
      let arr = val.map(n => Utils.filterData(n)).filter(n => n !== undefined)
      return arr.length > 0 ? arr : undefined
    }
    if (typeof val === 'object') {
      let obj = {}
      let newVal = null
      for(let k in val) {
        newVal = Utils.filterData(val[k])
        if (newVal !== undefined) {
          obj[k] = newVal
        }
      }
      return Utils.isEmptyObject(obj) ? undefined : obj
    }
    return Utils.isEmptyValue(val) ? undefined : val
  },
  debounce (fn, delay) { //函数防抖
    let timer = null
    return function () {
      clearTimeout(timer)
      const context = this
      const args = arguments
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  },
  throttle (fn, delay, init) { //函数节流
    let prev = init || 0
    let timer = null
    return function () {
      const context = this
      const args = arguments
      const now = Date.now()
      let d = now - prev
      if(d >= delay){
        clearTimeout(timer)
        fn.apply(context, args)
        prev = Date.now()
      } else {
        clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(context, args)
          prev = Date.now()
        }, delay - d)
      }
    }
  }
}

export default Utils
